export default {"src":"/_next/static/media/arrow_down_grey.2e322a83.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};